<template>
    <div class="panel-ring">
        <div class="panel-ring-top">
            <p class="panel-ring-top-title">{{ deviceTypeTitle }}</p>
            <key-value-unit class="panel-ring-top-sn" title="SN" :value="deviceSnDisplay"></key-value-unit>
        </div>
        <div class="panel-ring-content">
            <key-value-unit title="连接状态" :value="placeholderText(connectStatusStr)"></key-value-unit>
            <key-value-unit title="固件版本" :value="placeholderText(deviceData.swVersion)"></key-value-unit>
            <key-value-unit title="电池状态" :value="placeholderText(powerStatusStr)"></key-value-unit>
            <key-value-unit title="数据" :value="dataStatusStr"></key-value-unit>
        </div>
    </div>
</template>

<script>
import KeyValueUnit from "@c/monitor-center/device-detail-panel/key-value-unit.vue";

// 连接状态枚举
const CONNECT_STATE = {
    0: '未连接',
    1: '连接中',
    2: '已连接',
    3:'断开中',
};

// 电源状态枚举
const POWER_STATUS = {
    0: '正常',
    1: '充电中',
    2: '已充满',
    3: '低电',
    4:'异常',
    5: '停摆'
};

// 数据状态枚举
const DATA_STATUS = {
    0: '有效值',
    1: '准备中',
    2: '离手'
};

// 设备类型枚举 (根据deviceData.type)
const DEVICE_TYPE = {
    0: '监护仪',
    1: '智能指环',
    2: '脑电传感器',
    5: '心电传感器',
    10: '鼻气流传感器'
};



export default {
    components: {
        KeyValueUnit
    },

    props: {
        model: Object,
        deviceData: {
            type: Object,
            required: true
        }
    },

    computed: {
        // 设备类型标题
        deviceTypeTitle() {
            if (this.deviceData.type == null) {
                return '传感器';
            }
            return DEVICE_TYPE[this.deviceData.type] || '传感器';
        },

        // SN显示（根据model.deviceType添加后缀）
        deviceSnDisplay() {
            const sn = this.deviceData.deviceSn;
            if (!sn) {
                return this.placeholderText(null);
            }
            return sn;
        },

        // 连接状态
        connectStatusStr() {
            if (this.deviceData.connectState == null) {
                return null;
            }
            return CONNECT_STATE[this.deviceData.connectState] || '-';
        },

        // 电池状态
        powerStatusStr() {
            if (this.deviceData.powerStatus == null) {
                return null;
            }
            return POWER_STATUS[this.deviceData.powerStatus] || '-';
        },

        // 数据状态
        dataStatusStr() {
            if (this.deviceData.dataStatus == null) {
                return "-";
            }
            return DATA_STATUS[this.deviceData.dataStatus] || '-';
        }
    },

    methods: {
        placeholderText(text, unit) {
            return placeholderText(text, unit);
        }
    },
    mounted() {
        console.log('this.deviceData', this.deviceData)
    }
}
</script>

<style lang="scss" scoped>
.panel-ring {
    margin-top: rem(20);

    &-top {
        display: flex;
        align-items: center;

        &-title {
            font-size: rem(14);
            line-height: rem(20);
        }

        &-sn {
            margin-left: rem(74);
        }
    }

    &-content {
        display: flex;
        flex-wrap: wrap;

        .key-value-unit {
            margin-top: rem(10);
            width: 50%;
        }

        &-in-charge {
            color: #6CC291;
            font-size: rem(12);
            margin-left: rem(10);
        }
    }
}
</style>